// extracted by mini-css-extract-plugin
module.exports = {"popup_container":"popup_popup_container__4suwJ","popup_back":"popup_popup_back__3nMv4","popup":"popup_popup__2ErPy"};